import { formatPageCount } from '@helpers/utils';
import { withQueryParams } from '@hoc/withQueryParams';
import { useApi } from '@hooks/useApi';
import Pagination from '@stories/Components/Global/Pagination/Pagination';
import ScrollLoader from '@stories/Components/Global/ScrollLoader/ScrollLoader';
import NewsCard from '@stories/Components/NewsCard/NewsCard';
import ToggleBlock from '@stories/Components/ToggleBlock/ToggleBlock';
import * as React from 'react';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';
import S from './NewsListing.styles';
const NewsListing = ({ initialData, ...props }) => {
    const refContainer = React.useRef(null);
    const [params, setParams] = useQueryParams({
        brand: StringParam,
        newsType: StringParam,
        pageIndex: NumberParam,
        pageSize: NumberParam,
        region: StringParam,
    });
    const brand = params.brand ?? '';
    const newsType = params.newsType ?? '';
    const pageIndex = params.pageIndex ?? 1;
    const pageSize = params.pageSize ?? 12;
    const { data, loading } = useApi(`/api/news`, initialData, {
        brand,
        newsType,
        pageIndex,
        pageSize,
    });
    return (React.createElement(S.Container, { id: props.id, ref: refContainer },
        React.createElement(S.TopBar, null,
            React.createElement(S.Filters, null,
                React.createElement(ToggleBlock, { title: "Filter Options" },
                    React.createElement(S.FilterList, null,
                        React.createElement(S.FilterItem, null,
                            React.createElement(S.FilterLabel, { htmlFor: "newsType" }, "News Type"),
                            React.createElement(S.FilterSelect, { name: "newsType", id: "newsType", value: newsType, onChange: (event) => {
                                    setParams({ pageIndex: 1, newsType: event.target.value }, 'pushIn');
                                } },
                                React.createElement("option", { value: "" }, "Select News Type"),
                                data.newsTypeOptions.map((option) => (React.createElement("option", { key: option.value, value: option.value, disabled: option.disabled }, option.text))))),
                        React.createElement(S.FilterItem, null,
                            React.createElement(S.FilterLabel, { htmlFor: "brand" }, "Brand"),
                            React.createElement(S.FilterSelect, { name: "brand", id: "brand", value: brand, onChange: (event) => {
                                    setParams({ pageIndex: 1, brand: event.target.value }, 'pushIn');
                                } },
                                React.createElement("option", { value: "" }, "Select Brand"),
                                data.brandOptions.map((option) => (React.createElement("option", { key: option.value, value: option.value, disabled: option.disabled }, option.text)))))))),
            React.createElement(S.PageCount, null, formatPageCount(pageIndex, pageSize, data.totalItems)),
            React.createElement(S.PageSize, null,
                React.createElement(ToggleBlock, { title: "Items per page" },
                    React.createElement(S.FilterLabel, { htmlFor: "pageSize" }, "Items per page"),
                    React.createElement(S.FilterSelect, { name: "pageSize", id: "pageSize", value: pageSize, onChange: (event) => {
                            setParams({ pageIndex: 1, pageSize: parseInt(event.target.value, 10) }, 'pushIn');
                        } },
                        React.createElement("option", { value: "12" }, "Show 12"),
                        React.createElement("option", { value: "24" }, "Show 24"),
                        React.createElement("option", { value: "48" }, "Show 48"))))),
        React.createElement(S.ItemList, null, data.items.map((item) => (React.createElement(S.Item, { key: item.id },
            React.createElement(NewsCard, { ...item }))))),
        React.createElement(S.BottomBar, null,
            React.createElement(Pagination, { pageIndex: pageIndex, pageSize: pageSize, totalCount: data.totalItems, onPageIndexChange: (pageIndex) => {
                    setParams({ pageIndex: pageIndex }, 'pushIn');
                } })),
        React.createElement(ScrollLoader, { callback: () => {
                refContainer.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'start',
                });
            }, loading: loading })));
};
export default withQueryParams(NewsListing);
